import deepEqual from 'fast-deep-equal';
import PropTypes from 'prop-types';
import React from 'react';

import InputGroup from './Group/index.js';
import Input from './Input.jsx';
import MakeInput from './MakeInput.jsx';

const EnhancedTextInput = MakeInput(Input);
const EnhancedInput = React.forwardRef((props, ref) => (
  <EnhancedTextInput {...props} forwardedRef={ref} />
));

EnhancedInput.propTypes = {
  /**
   * The current value of the input, state must be handled by the caller
   */
  value: PropTypes.string,
  /**
   * A pre-filled initialValue for the input
   */
  initialValue: PropTypes.string,
  /**
   * The current state of the error, state must be handled by the caller
   */
  hasError: PropTypes.bool,
  /**
   * The rules the input must follow to be considered valid
   */
  rules: PropTypes.arrayOf(PropTypes.func),
  /**
   * Whether the input is required
   */
  isRequired: PropTypes.bool,
  /**
   * Defer validation until blur event
   */
  shouldValidateOnBlur: PropTypes.bool,
  /**
   * On change of the input's value
   */
  onChange: PropTypes.func,
  /**
   * On error of the input's value
   */
  onError: PropTypes.func,
  /**
   * On blur of the input
   */
  onBlur: PropTypes.func,
  /**
   * On focus of the input
   */
  onFocus: PropTypes.func,
  /**
   * On change of focus of the input
   */
  onChangeFocus: PropTypes.func,
  /**
   * Fired upon clicking the clear button of the input
   */
  onClear: PropTypes.func,
  /**
   * Whether the input is disabled
   */
  isDisabled: PropTypes.bool,
  /**
   * Whether the input is clearable
   */
  isClearable: PropTypes.bool,
  /**
   * If true, when only provided a label, the label will act
   * as a placeholder and once the input field is focused the label
   * jumps to above the input
   */
  shouldUseLabelAsPlaceholder: PropTypes.bool
};
EnhancedInput.defaultProps = {
  hasError: null,
  value: null,
  rules: [],
  onChange: () => 0,
  onClear: () => 0,
  onBlur: () => 0,
  onFocus: () => 0,
  onChangeFocus: () => 0,
  onError: () => 0,
  isDisabled: false,
  initialValue: '',
  shouldValidateOnBlur: false,
  isClearable: false,
  isRequired: false,
  shouldUseLabelAsPlaceholder: false
};
const Memoized = React.memo(EnhancedInput, deepEqual);
Memoized.Group = InputGroup;

export default Memoized;
